export default {
  admin: 'Amministratore',
  password: {
    enterNewPassword: 'Inserisci una nuova password',
    reenterNewPassword: 'Reinserisci la nuova password',
    updatePassword: 'Aggiorna password',
    setPassword: 'Imposta password',
    min8CharacterMessage: 'La password deve contenere almeno 8 caratteri',
    passwordSentMessage: 'La password è stata inviata a {userName} via e-mail.',
    generateNewPassword: 'Genera nuova password',
    assignPasswordMessage:
      "Assegna una password all'utente. L'utente dovrà cambiare questa password al prossimo accesso.",
    generateSecurePassword: 'Genera una password sicura',
    newPassword: 'Nuova password',
    confirmNewPassword: 'Conferma nuova password',
    passwordHistory: 'Cronologia delle password',
    passwordUpdatedLog: 'Password aggiornata da {userName} il {date}.',
    forgotPasswordLog: 'Richiesta di password dimenticata inviata da {userName} il {date}.',
  },
};
